import { redirect } from 'react-router-dom'
import { tokenService } from '../lib/token.service'

export const protectedLoader = () => {
  const user = tokenService.getUser()
  if (!user || user.id === '') {
    const currentPath = window.location.pathname + window.location.search
    const redirectParam = encodeURIComponent(currentPath)
    return redirect(`/auth/login?redirect=${redirectParam}`)
  }

  return null
}
